exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3QhIi{display:inline-block;background:#ebebeb;border-radius:2px;padding:0 5px;color:gray;margin:1px 2px 1px 0;font-size:10px;font-weight:400;line-height:10px;padding:3px 5px}", ""]);

// exports
exports.locals = {
	"root": "_3QhIi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/SpanWithBackground/SpanWithBackground.css
// module id = 1875
// module chunks = 15 18 19 20 37